<!-- 车型搜索 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-zone">
                    <div class="search-name">品牌</div>
                    <el-input class="search-item" size="small" ref="searchmodel" v-model="searchData.brand" placeholder="请输入品牌"></el-input>
                    <div class="search-name">车型</div>
                    <el-input class="search-item" size="small" ref="searchseries" v-model="searchData.series" placeholder="请输入车型"></el-input>
                    <div class="search-name">发动机</div>
                    <el-input class="search-item" size="small" ref="searchengine" v-model="searchData.engine" placeholder="请输入发动机"></el-input>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch" style="height: 32px">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch" style="height: 32px">重置</el-button>
                    <el-button class="search-btn btn-primary" size="small" @click="chooseModels()" style="height: 32px"
                        >确定 (选中{{ mulSelections.length }}项)</el-button
                    >
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <!-- v-el-table-infinite-scroll="tableLoad" -->
            <el-table
                highlight-current-row
                ref="selectSeriesTable"
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                @selection-change="onColumnSelect"
                height="397"
                border=""
                style="width: 100%; margin-bottom: 10px"
                @row-click="rowClick"
                :row-class-name="tableRowClassName"
                :row-key="getRowKeys"
            >
                <el-table-column type="selection" width="50" fixed="left" reserve-selection></el-table-column>
                <el-table-column label="品牌" prop="BrandName" show-overflow-tooltip></el-table-column>
                <el-table-column label="车型" prop="SeriesName" show-overflow-tooltip></el-table-column>
                <el-table-column label="发动机" prop="EngineType" show-overflow-tooltip></el-table-column>
                <el-table-column label="排量" prop="Emission" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="年款" prop="ModelYear" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="销售型" prop="SaleModel" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column label="变速箱" prop="TransmissionType" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="驱动" prop="DriveStyle" min-width="80" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
// import elTableInfiniteScroll from "@/assets/js/directives/table-infinite-scroll";
export default {
    name: '',
    props: {
        selectOptions: {
            type: Array
        }
    },
    data() {
        return {
            loading: false,
            mulSelections: [],
            searchData: {
                brand: '',
                series: '',
                engine: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            tableDataLength: 0,
            dataindex: 0,
            searchParams: {},
            currentRow: {},
            stopFresh: false
        };
    },
    mounted() {
        this.getTableData();
        this.$nextTick(() => {
            if (this.$refs.searchmodel) this.$refs.searchmodel.focus();
        });
    },
    //   directives: {
    //     "el-table-infinite-scroll": elTableInfiniteScroll
    //   },
    methods: {
        keyUpFunc() {
            let that = this;
            if (that.dataindex != 0) {
                that.dataindex--;
                let index = that.dataindex;
                that.$nextTick(() => {
                    if (that.$refs.searchmodel) that.$refs.searchmodel.blur();
                    if (that.$refs.selectSeriesTable) {
                        that.currentRow = that.$refs.selectSeriesTable.data[index];
                        that.$refs.selectSeriesTable.setCurrentRow(that.currentRow);
                    }
                });
            }
            return;
        },
        keyDownFunc() {
            let that = this;
            if (that.dataindex != that.tableData.length - 1) {
                if (that.currentRow && that.currentRow.AutoSerieId) {
                    that.dataindex++;
                } else that.dataindex = 0;
                let index = that.dataindex;
                that.$nextTick(() => {
                    if (that.$refs.searchmodel) that.$refs.searchmodel.blur();
                    if (that.$refs.selectSeriesTable) {
                        that.currentRow = that.$refs.selectSeriesTable.data[index];
                        that.$refs.selectSeriesTable.setCurrentRow(that.currentRow);
                    }
                });
            }
            return;
        },
        keyRightFunc() {
            let that = this;
            that.dataindex = -1;
            that.currentRow = {};
            let page = that.searchData.page;
            let limit = that.searchData.limit;

            let totalPages = Math.ceil(that.tableDataLength / limit);

            if (page < totalPages) {
                that.searchData.page += 1;
                that.getTableData();
            }
            return;
        },
        keyLeftFunc() {
            let that = this;
            that.dataindex = -1;
            that.currentRow = {};
            let page = that.searchData.page;
            if (page == 1) return;
            if (page > 1) that.searchData.page -= 1;
            that.getTableData();
            return;
        },
        keyEnterFunc() {
            let that = this;
            if (that.currentRow && that.currentRow.AutoSerieId) {
                that.$nextTick(() => {
                    if (that.$refs.selectSeriesTable) {
                        that.$refs.selectSeriesTable.toggleRowSelection(that.currentRow);
                    }
                });
            }
            return;
        },
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        resetSearch() {
            this.searchData = {
                brand: '',
                series: '',
                engine: '',
                page: 1,
                limit: 10
            };
            this.mulSelections = [];
            this.$refs.selectSeriesTable.clearSelection();
        },
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetAutoSeriesByKey',
                    data: that.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        if (that.searchData.page == 1) that.tableData = [];
                        return;
                    }

                    that.tableData = data;
                    that.tableDataLength = res.count;

                    that.$nextTick(() => {
                        //渲染选中
                        that.tableData.forEach(row => {
                            var index = that.mulSelections.findIndex(f => f.AutoSerieId === row.AutoSerieId);
                            if (~index) {
                                that.$refs.selectSeriesTable.toggleRowSelection(row, true);
                            }

                            if (that.selectOptions) {
                                index = that.selectOptions.findIndex(f => f[4].split('{$}')[0] === row.AutoSerieId);
                                if (~index) {
                                    that.$refs.selectSeriesTable.toggleRowSelection(row, true);
                                }
                            }
                        });
                    });
                })
                .catch(() => {})
                .finally(() => {
                    that.loading = false;
                });
        },
        handleSearch() {
            this.dataindex = 0;
            this.tableData = [];
            this.searchData.page = 1;
            this.getTableData();
            this.$nextTick(() => {
                if (this.$refs.searchmodel) this.$refs.searchmodel.blur();
            });
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        chooseModels() {
            let items = this.mulSelections;
            if (items && items.length > 0) {
                this.mulSelections = [];
                if (this.$refs.selectSeriesTable) this.$refs.selectSeriesTable.clearSelection();
                this.$emit('addToSelected', items);
            } else this.handleSearch();
        },
        onColumnSelect(val) {
            let list = val;
            const maps = new Map();
            list = list.filter(m => !maps.has(m.AutoSerieId) && maps.set(m.AutoSerieId, 1));

            this.mulSelections = list;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
        },
        getRowKeys(row) {
            return row.AutoSerieId;
        },
        inputDataChange() {
            let key = this.searchData.key;
            if (key) {
                this.searchData.key = key.replace('+', '');
            } else this.searchData.key = '';
        }
    }
};
</script>
<style lang="less" scoped>
.search-zone {
    display: flex;
    margin-bottom: 5px;
}
.search-ctn {
    margin-top: 5px;
}
.data-count {
    padding: 5px;
    display: flex;
    flex-direction: row-reverse;
}
.data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 12.5%;
    border-left: 1px solid @border4Color;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
        margin-bottom: 5px;
    }
}
</style>
<style lang="less">
.apig-table-ctn {
    .el-table {
        margin-bottom: 5px;
    }
}
</style>
